const LEGACY_PERMISSION_EQUIVALENTS = {
  'dashboard:read': ['reports:read'],
  'ledger:read': ['reports:read'],
  'invoices:read': ['invoice:read'],
  'invoices:write': ['invoice:write'],
  'quotations:read': ['invoice:read'],
  'quotations:write': ['invoice:write'],
  'estimatedInvoices:read': ['invoice:read'],
  'estimatedInvoices:write': ['invoice:write'],
  'products:read': ['master:read', 'master:write'],
  'products:write': ['master:write'],
  'customers:read': ['master:read', 'master:write'],
  'customers:write': ['master:write'],
  'taxes:read': ['master:read', 'master:write'],
  'taxes:write': ['master:write'],
  'settings:read': ['settings:write'],
  'settings:manage': ['settings:write'],
  'documentLayouts:read': ['settings:write'],
  'documentLayouts:manage': ['settings:write'],
  'documentFormLayouts:read': ['invoice:write'],
  'documentFormLayouts:edit': ['invoice:write'],
  'documentFormLayouts:share': ['settings:write'],
  'documentFormLayouts:setDefault': ['settings:write'],
  'fieldController:read': ['settings:write'],
  'fieldController:manage': ['settings:write'],
  'customFields:read': ['settings:write'],
  'customFields:manage': ['settings:write'],
  'campaigns:read': ['settings:write'],
  'campaigns:manage': ['settings:write'],
  'tenantUsers:read': ['settings:write'],
  'tenantUsers:manage': ['settings:write'],
};

export function normalizePermissions(permissions = []) {
  if (!Array.isArray(permissions)) {
    return [];
  }

  return [...new Set(permissions.filter((permission) => typeof permission === 'string' && permission.trim()))];
}

export function hasPermission(permissions = [], requiredPermission = '') {
  const normalizedPermissions = normalizePermissions(permissions);
  const normalizedRequired = String(requiredPermission || '').trim();
  if (normalizedPermissions.includes('*')) {
    return true;
  }

  if (!normalizedRequired) {
    return true;
  }

  if (normalizedPermissions.includes(normalizedRequired)) {
    return true;
  }

  return (LEGACY_PERMISSION_EQUIVALENTS[normalizedRequired] || []).some((legacyPermission) =>
    normalizedPermissions.includes(legacyPermission)
  );
}

export function hasAnyPermission(permissions = [], requiredPermissions = []) {
  const normalizedRequired = Array.isArray(requiredPermissions) ? requiredPermissions : [];
  if (!normalizedRequired.length) {
    return true;
  }

  return normalizedRequired.some((permission) => hasPermission(permissions, permission));
}

export function hasEveryPermission(permissions = [], requiredPermissions = []) {
  const normalizedRequired = Array.isArray(requiredPermissions) ? requiredPermissions : [];
  if (!normalizedRequired.length) {
    return true;
  }

  return normalizedRequired.every((permission) => hasPermission(permissions, permission));
}
